export const COMMENT_SIDEBAR_MIN_WIDTH = 320;

/** Default/minimum comment sidebar width (legacy alias). */
export const COMMENT_SIDEBAR_WIDTH = COMMENT_SIDEBAR_MIN_WIDTH;

export function getMaxCommentSidebarWidth(
  viewportWidth = typeof window !== "undefined" ? window.innerWidth : 1280,
): number {
  return Math.max(COMMENT_SIDEBAR_MIN_WIDTH, Math.floor(viewportWidth * 0.5));
}

export function clampCommentSidebarWidth(
  width: number,
  viewportWidth?: number,
): number {
  const min = COMMENT_SIDEBAR_MIN_WIDTH;
  const max = getMaxCommentSidebarWidth(viewportWidth);
  return Math.min(Math.max(width, min), max);
}
